import { Loader } from "@vds/loaders";
import { GridComponent } from "../../components/core/Table/GridComponent";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { lazy, useState, useEffect, useMemo, useContext } from "react";
import { Table, TableHead, TableBody, TableRow, Cell, TableHeader } from "@vds/tables";
import { css } from "@emotion/react";
import { FlexRow, SmallText, Spacer, SLNotification, MediumText } from "../../components/core/utility";
import { Button, TextLink } from "@vds/buttons";
import { groupBy } from "lodash";
import { bundleList, deleteBundle } from "../../services/C4S Decommission - Replacement/bundleList";
import { ViewVehicleList } from "../../services/C4S Decommission - Replacement/viewVehicleList";
import { OrderShippingSummaryAccordion } from "./OrderShippingSummaryAccordion";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import styled from "styled-components";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Icon } from "@vds/icons";
import { Tooltip } from "primereact/tooltip";
import FailedIcon from "../../assets/icons/ErrorIcon.svg";
import InProgressImg from "../../assets/icons/InProgress.svg";
import ErrorImg from "../../assets/icons/Error.svg";
import ReleasedImg from "../../assets/icons/Released.svg";
import ShippedImg from "../../assets/icons/Shipped.png";
import CancelImg from "../../assets/icons/Cancelled.svg";
import BackorderedImg from "../../assets/icons/Backordered.svg";
import ReturnSubmittedImg from "../../assets/icons/ReturnSubmitted.svg";
import SubmittedImg from "../../assets/icons/Submitted.svg";
import CreatedImg from "../../assets/icons/Created.svg";
import PackagingImg from "../../assets/icons/Packaging.svg";
import DeliveredImg from "../../assets/icons/Delivered.svg";
import { handleAddPage, switchTab, handleChangePage } from "./utils";
import { AddVehicleAssignmentMetadata } from "./AddVehicleAssignment";
import { AddAssetAssignmentMetadata } from "./AddAssetAssignment";
import { EditVehicleWTAMetadata } from "./EditVehicleWTAMetadata";
import EditVehicleWTAComponent from "../EditVehicleWTA/EditVehicleWTAComponent";
import AddKeyFobsModal from "./KeyFob/AddKeyFobsModal";
import { AssignHardwareGrid } from "./AssignHardwareGrid";
import { ASSIGN_HARDWARE_LIST_COLS } from "../../constants/AssignHardwareConstants";
import isEmpty from "lodash/isEmpty";
import { useToValidateKeyFobsQuantity } from "../../services/workticket/useToValidateKeyFobsQuantity";
import { validateVinQty } from "../../services/C4S Decommission - Replacement/validateVinQty";
import { C4SContext } from "../../context/c4sContext";
import InfoModal from "./InfoModal";
import DeleteModal from "./DeleteModal";
import { EXTRA_KEY_FOB } from "./KeyFob/keyFobConstant";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { messageBus } from "../../../utility/messageBus";

const isInIframe = () => {
  try {
    return window.location !== window.parent.location;
  } catch (e) {
    return true;
  }
};

const StyledIconContainer = styled.div`
  display: flex;
`;
const TableWrapper = styled.div`
  padding: 0 10px 0 16px;
  .p-datatable .p-datatable-tbody > tr {
    outline: none;
  }
  .p-datatable .p-datatable-header {
    padding-bottom: 0px !important;
    border-bottom: none !important;
  }
`;
const IconWrapper = styled.div`
  height: 24px;
  width: 24px;
  align-items: center;
  cursor: pointer;
  // margin-right: 10px;
  display: flex;
  margin-left: 2px;
  margin-bottom: 2px;
`;
const TextWrapper = styled.div`
  // height: 24px;
  // width: 24px;
  align-items: center;
  cursor: pointer;
  display: flex;
  // margin-left: 2px;
  // margin-bottom: 2px;
`;
const CustomTableHeader = css`
  margin-bottom: 0px;
  table-layout: fixed;
  thead {
    border-bottom: none;
    margin-bottom: 1px;
    th {
      padding: 0;
    }
  }
  td {
    padding: 2px 2px 2px 0px;
  }
`;

const TextLinkWrapper = styled(TextLink)`
  a:hover {
    color: #4c9aff;
  }
`;
export const AccordionWrapper = styled.div`
  // padding-top: 2.5rem;
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    // border: none;
    padding: 0.5rem;
    background: lightgray;
    // box-shadow: unset;
    border-radius: 10px !important;
    margin-bottom: 0.6rem;
  }
  padding-top: 0.8rem;
  // padding-bottom: 0.8rem;

  .p-accordion .p-accordion-content {
    padding: 0rem;
    // border: none;
    padding-bottom: 0.8rem;
  }
  .p-accordion-header-text {
    font-weight: 500;
    font-family: Verizon-NHG-eDS;
    font-size: 0.8rem;
    border-radius: 10px;
  }
  .p-accordion-toggle-icon {
    order: 1;
    margin-left: auto;
  }
`;

// Helper function to render vehicle status with bold numbers
const renderVehicleStatus = (material) => {
  const notEntered =
    Number(material[0].Quantity) -
    (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
  const ready = Number(material[0].vehicle?.ready) || 0;
  const warnings = Number(material[0].vehicle?.warnings) || 0;
  const falloutValue = Number(material[0].fallout) || 0;
  const remaining = notEntered - falloutValue >= 0 ? notEntered - falloutValue : 0;
  const parts = [
    { value: remaining, label: "Remaining" },
    { value: warnings, label: "Needs Attention" },
    { value: ready, label: "Ready" },
  ];
  return parts.map((part, idx) => (
    <span key={idx}>
      <b>{part.value}</b> {part.label}
      {idx < parts.length - 1 ? <span>{"\u00A0\u00A0\u00A0\u00A0"}</span> : null}
    </span>
  ));
};

const AssignHardware = (props) => {
  const [isLoading, setLoader] = useState(false);
  const cspData = props?.cspData?.data?.data || {};
  const accountId = props?.cspData?.data?.data?.AccountID;
  let productData = groupBy(props?.cspData?.data?.data?.Product, "BundleId");
  const isWTA = sessionStorage.getItem("isWTA") === "true";
  const [cspDetailsData] = useState(Object.values(productData));
  const [productDetails, setProductDetails] = useState([]);
  const [vehiclleList, setVehicleList] = useState([]);
  const [notification, setNotification] = useState(null);
  const [activeIndex, setActiveIndex] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState(null);
  const [selectedBundleName, setSelectedBundleName] = useState("");
  const [selectedBundleId, setSelectedBundleId] = useState("");
  const [bundleData, setBundleData] = useState({});
  const [assetType, setAssetType] = useState("");
  const [isKeyFobsOpen, setKeyFobsOpen] = useState(false);
  const [selectedKeyFobRow, setSelectedKeyFobRow] = useState();
  const { data, error, isLoading: isKeyFobLoading, validateKeyFobsQuantity } = useToValidateKeyFobsQuantity();

  const renderImage = (data) => {
    let workTicketStatus = data?.wtstatus?.toLowerCase();
    let statusIcon;
    switch (workTicketStatus) {
      case "error":
        statusIcon = ErrorImg;
        break;
      case "released":
        statusIcon = ReleasedImg;
        break;
      case "shipped":
        statusIcon = ShippedImg;
        break;
      case "cancelled":
        statusIcon = CancelImg;
        break;
      case "return submitted":
        statusIcon = ReturnSubmittedImg;
        break;
      case "backordered":
        statusIcon = BackorderedImg;
        break;
      case "submitted":
        statusIcon = SubmittedImg;
        break;
      case "created":
        statusIcon = CreatedImg;
        break;
      case "packaging":
        statusIcon = PackagingImg;
        break;
      case "delivered":
        statusIcon = DeliveredImg;
        break;
      default:
        statusIcon = InProgressImg;
    }
    return statusIcon;
  };

  const renderWorkTicketStatus = (item, index, prefix = "") => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <SmallText>{item?.workTicketId || "--"}</SmallText>
      {item?.wtstatus && (
        <div style={{ marginLeft: "5px" }}>
          <Tooltip target={`.wt-status-${prefix}${item?.workTicketId?.replace(/[^a-zA-Z0-9]/g, "")}-${index}`} mouseTrack mouseTrackLeft={10} />
          <img
            alt="Work Ticket Status"
            className={`wt-status-${prefix}${item?.workTicketId?.replace(/[^a-zA-Z0-9]/g, "")}-${index}`}
            src={renderImage(item)}
            height="16px"
            width="16px"
            data-pr-tooltip={item?.wtstatus}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
    </div>
  );

  useEffect(() => {
    if (isLoading || isEmpty(data)) return;

    if (isEmpty(error)) {
      data?.availableQty <= 0 ? setInfoModalOpened(true) : setKeyFobsOpen(true);
    } else {
      notify(error, "error");
    }
  }, [data, error, isKeyFobLoading]);

  const { cspDetails, workTicketInfo } = useContext(C4SContext);
  const [infoModalOpened, setInfoModalOpened] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const [selectedRecordForDelete, setSelectedRecordForDelete] = useState(null);
  const [materialBundleList, setMaterialBundleList] = useState([]);

  useEffect(() => {
    const closeHandler = () => {
      setActiveIndex([]); // Resets the state to close all accordions
    };

    messageBus.on("closeAccordions", closeHandler);

    return () => {
      messageBus.off("closeAccordions", closeHandler);
    };
  }, []);
  useEffect(() => {
    let data = [];
    cspDetailsData.map((material) => {
      data.push(material[0].BundleId);
    });
    setMaterialBundleList(data);
    getBundleList(data);
  }, [activeIndex.length]);

  const closeInfoModal = () => {
    setInfoModalOpened(false);
  };

  const handleTabChange = async (e, index, data, bundleId) => {
    productDetails.map((material, i) => {
      if (i === index) {
        setActiveIndex((prev) => {
          const newIndexes = [...prev];
          newIndexes[i] = e.index;
          return newIndexes;
        });
      } else {
        setActiveIndex((prev) => {
          const newIndexes = [...prev];
          newIndexes[i] = null;
          return newIndexes;
        });
      }
    });

    if (e.index !== null) {
      setVehicleList([]);
      setLoader(true);
      let response = await ViewVehicleList(bundleId, data[e.index].addressId, data[e.index].contactId, props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID);
      if (response.status === 200 && response.data?.data) {
        setVehicleList(response.data?.data?.vehicles[`${bundleId}`]);
        setLoader(false);
      } else {
        setLoader(false);
        notify("Something went wrong, please try again.", "error");
        setTimeout(() => {
          setNotification(null);
        }, 5000);
      }
    }
  };

  const handleClickOutside = () => {
    setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);

  const getBundleList = async (payload) => {
    setLoader(true);
    let response = await bundleList(payload, props?.AccountID);
    if (response.status === 200 && response.data?.data) {
      cspDetailsData.map((material) => {
        response.data?.data.map((data) => {
          if (data.bundleId === material[0].BundleId) {
            material[0].vehicle = data.vehicle;
            material[0].shipGroups = data.shipGroups;
            material[0].vehicleIsPresent = data?.vehicleIsPresent;
            material[0].vin = data?.vin;
            material[0].deleteEligible = data?.deleteEligible;
          }
        });
      });
      cspDetailsData.map((material) => {
        if (material[0].vehicle) {
          const notEntered =
            Number(material[0].Quantity) -
            (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
          let displayString;
          if (notEntered > 0) {
            let parts = [];
            if (notEntered > 0) parts.push(`${notEntered} Remaining`);
            if (material[0].vehicle?.warnings > 0) parts.push(`${material[0].vehicle?.warnings} Needs Attention`);
            if (material[0].vehicle?.ready > 0) parts.push(`${material[0].vehicle?.ready} Ready`);
            displayString = parts.join("\u00A0\u00A0\u00A0\u00A0");
          } else {
            let parts = [];
            if (material[0].vehicle?.warnings > 0) parts.push(`${material[0].vehicle?.warnings} Needs Attention`);
            if (material[0].vehicle?.ready > 0) parts.push(`${material[0].vehicle?.ready} Ready`);
            displayString = parts.join("\u00A0\u00A0\u00A0\u00A0");
          }
          material[0].vehicle = { ...material[0].vehicle, displayString: displayString };
        }
      });
      setProductDetails(cspDetailsData);
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };
  const editVehicle = (data, bundleName, bundleId, bundleData, assetType) => {
    let isEditable = true;
    if (data.vehicleStatus === "Warning" || data.changeVehicleEligible) {
      isEditable = true;
    } else {
      const allMaterialsSubmitted = data.materialMapping.every((material) => material.status.toLowerCase() === "submitted");
      if (allMaterialsSubmitted) {
        isEditable = false;
      }
    }

    if (isEditable) {
      handleAddPage(EditVehicleWTAMetadata.id, {
        data,
        bundleName,
        bundleId,
        bundleData,
        assetType,
      });
    }
  };

  const isVehicleEditable = (data) => {
    if (data.vehicleStatus === "Warning" || data.changeVehicleEligible) {
      return true;
    }
    const allMaterialsSubmitted = data.materialMapping.every((material) => material.status.toLowerCase() === "submitted");
    return !allMaterialsSubmitted;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <FlexRow css={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        {rowData?.enabled ? (
          <div
            onClick={() => {
              deleteRow(rowData, "Delete Key Fob");
            }}
          >
            <Icon
              className="trash-icon"
              aria-label="Delete"
              alt="delete-icon"
              name="trash"
              size="medium"
              color="#000000"
              style={{ cursor: "pointer", outline: "none" }}
            />
          </div>
        ) : (
          <></>
        )}
      </FlexRow>
    );
  };

  const deleteRow = (row, type) => {
    setDeleteModalOpened(true);
    setSelectedRecordForDelete({ row, type });
  };

  const closeDeleteModal = () => {
    setDeleteModalOpened(false);
    setSelectedRecordForDelete(null);
  };

  const handleConfirmDelete = async () => {
    setLoader(true);
    let response;
    if (selectedRecordForDelete.type === "Delete Vehicle" || selectedRecordForDelete.type === "Delete Asset") {
      let payload = {
        bundleId: null,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        vinId: selectedRecordForDelete.row.id,
      };
      response = await deleteBundle(payload);
    }
    //bulk delete payload
    else if (selectedRecordForDelete.type === "Bulk Delete") {
      let payload = {
        bundleId: selectedRecordForDelete.row.BundleId,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        vinId: null,
      };
      response = await deleteBundle(payload);
    } else if (selectedRecordForDelete.type === "Delete Key Fob") {
      let payload = {
        bundleId: null,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        vinId: selectedRecordForDelete?.row?.vehicleId,
      };
      response = await deleteBundle(payload);
    }

    if (response.status === 200 && response.data?.data) {
      setDeleteModalOpened(false);
      setSelectedRecordForDelete(null);
      notify("Deleted successfully", "success");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
      switchTab(1);
    } else {
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
    setLoader(false);
  };

  const showActionIcon = (row) => (
    <FlexRow>
      <div
        onClick={() => {
          deleteRow(row, "Delete Vehicle");
        }}
      >
        <Icon
          className="trash-icon"
          aria-label="Delete"
          alt="delete-icon"
          name="trash"
          size="medium"
          color="#000000"
          style={{ cursor: "pointer", outline: "none" }}
        />
      </div>
    </FlexRow>
  );

  const openModal = (assetType, bundleId, quantity, material) => {
    getValidateVinQty(assetType, bundleId, quantity, material);
  };

  const getValidateVinQty = async (assetType, bundleId, quantity, material) => {
    setLoader(true);
    let payload = {
      accountId: cspDetails.cspDetails.accountId,
      crmRefId: workTicketInfo.workTicketInfo.crmRefId,
      bundleId: bundleId,
      maxQty: quantity,
      type: assetType === "Vehicle" ? "VEHICLE" : "ASSET",
      kfbTechRefId: "",
    };
    let response = await validateVinQty(payload);
    if (response.status === 200 && response.data?.data) {
      const availableQuantity = response?.data?.data?.availableQty - Number(material[0].fallout);
      if (availableQuantity <= 0) {
        setAssetType(assetType);
        setInfoModalOpened(true);
      } else {
        setInfoModalOpened(false);
        const data = {};
        data.productInfo = material;
        data.availableQty = availableQuantity;
        assetType === "Vehicle" ? handleAddPage(AddVehicleAssignmentMetadata.id, data) : handleAddPage(AddAssetAssignmentMetadata.id, data);
      }
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  const getExtraKeyFob = useMemo(() => {
    const extraKeyFob = [];
    if (vehiclleList?.length) {
      vehiclleList?.forEach((vehicle) => {
        if (vehicle?.deviceType === "KEYFOB") {
          const filteredKeyFob = vehicle?.materialMapping.map((el, index) => ({
            ...el,
            vehicleId: vehicle.id,
            keyfob: "KeyFob",
            hardwareTitle: el?.hardwareName + "-" + el?.hardwareId,
            type: el?.type + "-" + el?.subType,
            subscriptionName: el?.subscriptionName + "-" + el?.subscriptionId,
            hardwareName: el?.hardwareName + "-" + el?.hardwareId,
            workticketId: renderWorkTicketStatus(el, index, "keyfob-"),
            wtstatus: el?.wtstatus,
            ticketType: el?.lineType,
          }));
          extraKeyFob.push(...filteredKeyFob);
        }
      });
    }
    return extraKeyFob;
  }, [vehiclleList]);

  return (
    <>
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            Assign Hardware
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          {"\u00A0"}
        </BreadcrumbItem>
      </Breadcrumbs>
      <Spacer top="1rem" />
      {notification}
      {isWTA && <OrderShippingSummaryAccordion></OrderShippingSummaryAccordion>}
      <Spacer top="1rem" />
      {infoModalOpened && <InfoModal isOpen={infoModalOpened} onClose={closeInfoModal} handleConfirmOk={closeInfoModal} assetType={assetType} />}
      <Loader active={isLoading} fullscreen />
      {isKeyFobsOpen && (
        <AddKeyFobsModal
          open={isKeyFobsOpen}
          close={(value, isSuccess = false) => {
            if (isSuccess) {
              getBundleList(materialBundleList);
            }
            setKeyFobsOpen(value);
          }}
          cspData={cspData}
          keyFobData={data}
          selectedKeyFobRow={selectedKeyFobRow}
        />
      )}

      {productDetails.map((material, index) => {
        return (
          <>
            <FlexRow
              css={{
                backgroundColor: "black",
                padding: "5px 0 5px 8px",
                width: "100%",
                fontSize: "14px",
                color: "white",
                borderRadius: "5px",
              }}
            >
              <div css={{ marginTop: "4px" }}>
                {material[0].BundleName} ({material[0].BundleId})
              </div>
              {material[0].vehicle?.displayString == null ? (
                <div css={{ marginLeft: "3rem", marginTop: "4px" }}></div>
              ) : (
                <div css={{ marginLeft: "3rem", marginTop: "4px" }}>{renderVehicleStatus(material)}</div>
              )}

              {/* Bulk delete functionality */}
              <div style={{ display: "flex", marginLeft: "auto" }}>
                {material[0]?.shipGroups?.length > 0 && Number(material[0]?.deleteEligible) > 0 ? (
                  <Button
                    onClick={() => {
                      deleteRow(material[0], "Bulk Delete");
                    }}
                    size="small"
                    aria-label="Delete Vehicle"
                    role="button"
                    css={{ padding: 0, backgroundColor: "white", borderRadius: "5px", marginLeft: "auto", marginRight: "15px", color: "black" }}
                  >
                    {material[0].AssetType === "Vehicle" ? "Delete Vehicles" : "Delete Assets"}
                  </Button>
                ) : (
                  <Button
                    onClick={() => {}}
                    size="small"
                    aria-label="Delete Vehicle"
                    role="button"
                    css={{ padding: 0, backgroundColor: "#C4C4C4", borderRadius: "5px", marginLeft: "auto", marginRight: "15px", color: "black" }}
                    disabled={true}
                  >
                    {material[0].AssetType === "Vehicle" ? "Delete Vehicles" : "Delete Assets"}
                  </Button>
                )}
                <Button
                  size="small"
                  aria-label="Add Vehicle"
                  role="button"
                  css={{
                    padding: 0,
                    backgroundColor: "white",
                    borderRadius: "5px",
                    marginRight: "1rem",
                    color: "black",
                    marginLeft: "auto",
                  }}
                  onClick={() => {
                    openModal(material[0].AssetType, material[0].BundleId, material[0].Quantity, material);
                  }}
                >
                  {material[0].AssetType === "Vehicle" ? "Add Vehicle & Address" : "Add Asset & Address"}
                </Button>
              </div>
            </FlexRow>
            <Spacer top="15px" />
            <div css={{ width: "80%" }}>
              <Table tabIndex={0} role="table" topLine="none" css={CustomTableHeader}>
                <TableHead tabIndex={0} role="columnheader">
                  <TableHeader tabIndex={0} role="columnheader" width="9%">
                    <SmallText bold>Type</SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="30%">
                    <SmallText bold>Subscription Name</SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="14%">
                    <SmallText bold>Subscription ID</SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="22%">
                    <SmallText bold> Tech Ref ID </SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="12%">
                    <SmallText bold> Order Type </SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="9%">
                    <SmallText bold> Ordered </SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="8%">
                    <SmallText bold> Fallout </SmallText>
                  </TableHeader>
                  <TableHeader tabIndex={0} role="columnheader" width="13%">
                    <SmallText bold> Actions </SmallText>
                  </TableHeader>
                </TableHead>
              </Table>
              <Table role="table" topLine="none" striped={false} css={CustomTableHeader}>
                <TableBody role="rowgroup">
                  {material.map((data, index) => {
                    return (
                      <TableRow role="row" key={data.materialId + index}>
                        <Cell tabIndex={0} role="cell" width="9%">
                          <SmallText>{data.featureType}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="30%">
                          <SmallText>{data.ProductName}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="14%">
                          <SmallText>{data.SAPProductID}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="22%">
                          <SmallText>{data.TechRefId}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="12%">
                          <SmallText>{data.OrderDetailType}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="9%">
                          <SmallText>{data.Quantity}</SmallText>
                        </Cell>
                        <Cell tabIndex={0} role="cell" width="8%">
                          <SmallText>{data.fallout !== null && data.fallout !== undefined && data.fallout > 0 ? data.fallout : "--"}</SmallText>
                        </Cell>

                        <Cell tabIndex={0} role="cell" width="13%">
                          {data?.ProductName?.toLowerCase() === "key fob id" ? (
                            <TextLinkWrapper
                              size="small"
                              type="inline"
                              tabIndex="0"
                              role="link"
                              style={{ fontSize: "12px" }}
                              disabled={!material[0]?.vehicleIsPresent}
                              onClick={() => {
                                setSelectedKeyFobRow({ ...data, vin: material[0]?.vin });
                                validateKeyFobsQuantity({
                                  accountId: accountId,
                                  crmRefId: workTicketInfo?.workTicketInfo?.crmRefId,
                                  bundleId: data?.BundleId,
                                  maxQty: Number(data?.Quantity),
                                  type: "KEYFOB",
                                  kfbTechRefId: data?.TechRefId,
                                });
                              }}
                            >
                              Assign To Address
                            </TextLinkWrapper>
                          ) : (
                            "--"
                          )}
                        </Cell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
            {/* <Spacer top="5px" /> */}

            {material[0].AssetType === "Vehicle" ? (
              <AccordionWrapper>
                <Accordion
                  expandIcon="pi pi-plus"
                  collapseIcon="pi pi-minus"
                  activeIndex={activeIndex[index]}
                  onTabChange={(e) => {
                    handleTabChange(e, index, material[0].shipGroups, material[0].BundleId);
                  }}
                >
                  {material[0].shipGroups?.map((data) => {
                    return (
                      <AccordionTab
                        key={data.materialId}
                        iconPos="end"
                        header={
                          <div css={{ fontSize: "14px" }}>
                            Ship to <b>{data.contactName}</b> at <b>{data.address}</b>
                          </div>
                        }
                      >
                        {!!getExtraKeyFob?.length && !vehiclleList?.filter((row) => row.deviceType !== "KEYFOB")?.length ? (
                          <></>
                        ) : (
                          <AssignHardwareGrid
                            rows={vehiclleList?.filter((row) => row.deviceType !== "KEYFOB")}
                            columns={ASSIGN_HARDWARE_LIST_COLS}
                            showActionIcon={showActionIcon}
                            editVehicle={editVehicle}
                            isVehicleEditable={isVehicleEditable}
                            bundleName={material[0].BundleName}
                            bundleId={material[0].BundleId}
                            shipGroupsData={data}
                            assetType={material[0].AssetType}
                          />
                        )}

                        {!!getExtraKeyFob?.length && (
                          <>
                            <Spacer top="20px" css={{ padding: "0.2rem", background: "#747676", marginBottom: "0.3rem", borderRadius: "10px" }} />
                            <TableWrapper>
                              <GridComponent
                                isExportEnabled={false}
                                noDataMessage="No data available to display"
                                rows={getExtraKeyFob}
                                actionColumn=" "
                                showActionIcon={actionBodyTemplate}
                                columns={EXTRA_KEY_FOB}
                                hideGlobalFilter={true}
                                keyfob={true}
                                whiteSpace="normal"
                                paginator={false}
                                hyperLinkClicked={(data) => {}}
                              />
                            </TableWrapper>
                          </>
                        )}
                      </AccordionTab>
                    );
                  })}
                </Accordion>
              </AccordionWrapper>
            ) : (
              <AccordionWrapper>
                <Accordion
                  expandIcon="pi pi-plus"
                  collapseIcon="pi pi-minus"
                  activeIndex={activeIndex[index]}
                  onTabChange={(e) => {
                    handleTabChange(e, index, material[0].shipGroups, material[0].BundleId);
                  }}
                >
                  {material[0].shipGroups?.map((data) => {
                    return (
                      <AccordionTab
                        key={data.materialId}
                        iconPos="end"
                        header={
                          <div css={{ fontSize: "14px" }}>
                            Ship to <b>{data.contactName}</b> at <b>{data.address}</b>
                          </div>
                        }
                      >
                        <>
                          <Table tabIndex={0} role="table" topLine="none" css={CustomTableHeader}>
                            <TableHead tabIndex={0} role="columnheader">
                              <TableHeader tabIndex={0} role="columnheader" width="10%">
                                <SmallText bold>Asset</SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="10%">
                                <SmallText bold>Hardware Status</SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="10%">
                                <SmallText bold> Category </SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="17%">
                                <SmallText bold> Subscription</SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="17%">
                                <SmallText bold> Tech Ref ID </SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="8%">
                                <SmallText bold> Type </SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="17%">
                                <SmallText bold>Hardware</SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="12%">
                                <SmallText bold> WorkTicket </SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="8%">
                                <SmallText bold> Delivery Date </SmallText>
                              </TableHeader>
                              <TableHeader tabIndex={0} role="columnheader" width="5%">
                                <SmallText bold> </SmallText>
                              </TableHeader>
                            </TableHead>
                          </Table>
                          <Table role="table" topLine="none" striped={false} css={CustomTableHeader}>
                            <TableBody role="rowgroup">
                              {vehiclleList?.map((vehicleData) => {
                                const isEditable = isVehicleEditable(vehicleData);
                                return (
                                  <TableRow
                                    role="row"
                                    key={vehicleData.id}
                                    style={
                                      vehicleData.materialMapping[0].status.toLowerCase() === "submitted"
                                        ? {
                                            backgroundColor: "#f5f5f5",
                                            opacity: 0.6,
                                            pointerEvents: "none",
                                          }
                                        : {}
                                    }
                                  >
                                    <Cell tabIndex={0} role="cell" width="10%">
                                      <SmallText
                                        css={{
                                          textDecoration: isEditable ? "underline" : "none",
                                          cursor: isEditable ? "pointer" : "not-allowed",
                                        }}
                                        onClick={() =>
                                          editVehicle(vehicleData, material[0].BundleName, material[0].BundleId, data, material[0].AssetType)
                                        }
                                      >
                                        {vehicleData.materialMapping.map((item, i) => {
                                          return <SmallText key={i}>{"Powered Asset"}</SmallText>;
                                        })}
                                      </SmallText>
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="10%">
                                      {vehicleData.vehicleStatus === "Warning" && vehicleData?.comment?.length > 0 && (
                                        <StyledIconContainer>
                                          <IconWrapper css={{ marginLeft: "-15px" }}>
                                            <Tooltip target=".errorlogo" mouseTrack mouseTrackLeft={10} />
                                            <img
                                              alt="Error icon"
                                              className="errorlogo"
                                              src={FailedIcon}
                                              height="16px"
                                              width="16px"
                                              aria-label="Error"
                                              data-pr-tooltip={vehicleData?.comment}
                                            ></img>
                                          </IconWrapper>
                                          <SmallText>Needs Attention</SmallText>
                                        </StyledIconContainer>
                                      )}

                                      {vehicleData.vehicleStatus === "Warning" && vehicleData?.comment == null && (
                                        <StyledIconContainer>
                                          <SmallText>Needs Attention</SmallText>
                                        </StyledIconContainer>
                                      )}

                                      {vehicleData.vehicleStatus === "Ready" && vehicleData?.comment?.length > 0 && (
                                        <StyledIconContainer>
                                          <IconWrapper
                                          // css={{ marginLeft: "-15px" }}
                                          >
                                            <Tooltip target=".errorlogo" mouseTrack mouseTrackLeft={10} />
                                            <img
                                              alt="Error icon"
                                              className="errorlogo"
                                              src={FailedIcon}
                                              height="16px"
                                              width="16px"
                                              css={{ visibility: vehicleData?.comment?.length > 0 ? "visible" : "hidden" }}
                                              aria-label="Error"
                                              data-pr-tooltip={vehicleData?.comment}
                                            ></img>
                                          </IconWrapper>
                                          <TextWrapper>
                                            <Tooltip target=".info" mouseTrack mouseTrackLeft={10} />
                                            {Number(vehicleData.priority) === 1 ? (
                                              <SmallText data-pr-tooltip="Hardware Recommended" className="info">
                                                {vehicleData.vehicleStatus}
                                              </SmallText>
                                            ) : (
                                              <SmallText data-pr-tooltip="Hardware Specified" className="info">
                                                {vehicleData.vehicleStatus}
                                              </SmallText>
                                            )}
                                          </TextWrapper>
                                        </StyledIconContainer>
                                      )}

                                      {vehicleData.vehicleStatus === "Ready" && vehicleData?.comment == null && (
                                        <StyledIconContainer>
                                          <TextWrapper>
                                            <Tooltip target=".info" mouseTrack mouseTrackLeft={10} />
                                            {Number(vehicleData.priority) === 1 ? (
                                              <SmallText data-pr-tooltip="Hardware Recommended" className="info">
                                                {vehicleData.vehicleStatus}
                                              </SmallText>
                                            ) : (
                                              <SmallText data-pr-tooltip="Hardware Specified" className="info">
                                                {vehicleData.vehicleStatus}
                                              </SmallText>
                                            )}
                                          </TextWrapper>
                                        </StyledIconContainer>
                                      )}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="10%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return (
                                          <SmallText key={i}>
                                            {item.type}
                                            {"-"}
                                            {item.subType}
                                          </SmallText>
                                        );
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="17%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return (
                                          <SmallText key={i}>
                                            {item.subscriptionName}
                                            {"-"}
                                            {item.subscriptionId}
                                          </SmallText>
                                        );
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="17%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return <SmallText key={i}>{item.techRefId}</SmallText>;
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="8%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return <SmallText key={i}>{item.lineType ? item.lineType : "--"}</SmallText>;
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="17%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return (
                                          <SmallText key={i}>
                                            {item.hardwareName}
                                            {"-"}
                                            {item.hardwareId}
                                          </SmallText>
                                        );
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="12%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        const uniqueId = `asset-${vehicleData.id}-${i}`;
                                        return (
                                          <div key={i} style={{ marginBottom: i < vehicleData.materialMapping.length - 1 ? "2px" : "0" }}>
                                            <Tooltip target={`.wt-status-${uniqueId}`} mouseTrack mouseTrackLeft={10} />
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              <SmallText>
                                                {!(
                                                  (item.status === "Ready" || item.status === "Warning") &&
                                                  item.wtstatus?.toLowerCase() !== "cancelled"
                                                )
                                                  ? item?.workTicketId || "--"
                                                  : "--"}
                                              </SmallText>
                                              {!(
                                                (item.status === "Ready" || item.status === "Warning") &&
                                                item.wtstatus?.toLowerCase() !== "cancelled"
                                              ) &&
                                                item?.wtstatus && (
                                                  <div style={{ marginLeft: "5px", pointerEvents: "auto" }}>
                                                    <img
                                                      alt="Work Ticket Status"
                                                      className={`wt-status-${uniqueId}`}
                                                      src={renderImage(item)}
                                                      height="16px"
                                                      width="16px"
                                                      data-pr-tooltip={item?.wtstatus}
                                                      style={{ cursor: "pointer", pointerEvents: "auto" }}
                                                    />
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="8%">
                                      {vehicleData.materialMapping.map((item, i) => {
                                        return <SmallText key={i}>{item.deliveryDate || "--"}</SmallText>;
                                      })}
                                    </Cell>
                                    <Cell tabIndex={0} role="cell" width="5%">
                                      {vehicleData.materialMapping[0].status.toLowerCase() !== "submitted" && (
                                        <FlexRow css={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                          <div
                                            onClick={() => {
                                              deleteRow(vehicleData, "Delete Asset");
                                            }}
                                          >
                                            <Icon
                                              className="trash-icon"
                                              aria-label="Delete"
                                              alt="delete-icon"
                                              name="trash"
                                              size="medium"
                                              color="#000000"
                                              style={{ cursor: "pointer", outline: "none" }}
                                            />
                                          </div>
                                        </FlexRow>
                                      )}
                                    </Cell>
                                  </TableRow>
                                );
                              })}
                              {vehiclleList?.length === 0 && <div css={{ textAlign: "center" }}>No data available</div>}
                            </TableBody>
                          </Table>
                        </>
                      </AccordionTab>
                    );
                  })}
                </Accordion>
              </AccordionWrapper>
            )}
          </>
        );
      })}
      {deleteModalOpened && (
        <DeleteModal
          isOpen={deleteModalOpened}
          onClose={closeDeleteModal}
          title={selectedRecordForDelete?.type}
          row={selectedRecordForDelete?.row}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
    </>
  );
};
export default AssignHardware;

export const AssignHardwareMetadata = {
  name: "Assign Hardware",
  id: "assign_hardware",
  component: lazy(() => import("./AssignHardware")),
  route: "/assign_hardware",
};
